export const DEFAULT_NAV_PAGE = 'records';

export const NOTIFICATION_PREFS = [
  {
    key: 'notifyCheckedOut',
    label: 'Evidence Checked Out',
    desc: 'Get notified when your submitted evidence is checked out',
  },
  {
    key: 'notifyTransferred',
    label: 'Evidence Transferred',
    desc: 'Get notified when your submitted evidence is transferred or transported',
  },
  {
    key: 'notifyCorrResolved',
    label: 'Correction Resolved',
    desc: 'Get notified when a correction request you submitted is resolved',
  },
  {
    key: 'notifyDisposed',
    label: 'Evidence Disposed',
    desc: 'Get notified when your submitted evidence is disposed of',
  },
];

export const buildDefaultNotificationValues = () => {
  const values = {};
  NOTIFICATION_PREFS.forEach((item) => {
    values[item.key] = true;
  });
  return values;
};
